import React from "react";

interface CheckboxProps {
    id?: string;
    checked: boolean;
    onChange: (value: boolean) => void;
    isFilled?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({ id, checked, onChange, isFilled = true }) => {
    const click = () => {
        onChange(!checked);
    }

    return (
        <>
            <input id={ id } type="checkbox" className="hidden" checked={ checked }
                   onChange={ (e) => onChange(e.target.checked) }/>
            <div className="cursor-pointer mr-3" onClick={ () => click() }>{ checked &&
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="24" height="24" rx="6" fill="#FFCC33"/>
                    <g clipPath="url(#clip0_159_8419)">
                        <path d="M6.5625 11.8125L11.2292 15.9375L17.4375 8.0625" stroke="#12100B" strokeWidth="1.5"
                              strokeLinecap="round"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_159_8419">
                            <rect width="18" height="18" fill="white" transform="translate(3 3)"/>
                        </clipPath>
                    </defs>
                </svg>
            }
                { !checked && isFilled &&
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="24" height="24" rx="6" fill="#FFCC33"/>
                    </svg>
                }
                { !checked && !isFilled &&
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="23" height="23" rx="5.5" stroke="#E8E8E8"/>
                    </svg>
                }
            </div>
        </>
    )
}